<template>
  <div class="text-13 h-6 flex items-center">
    Schedule
    <span class="font-600 text-red-700" v-if="!workflow">&nbsp;Select Workflow</span>
    <span v-if="workflow">
      <span class="font-600">&nbsp;{{ workflow }}</span>
      agent/flow to run
    </span>

    <span class="font-600" v-if="item.payload?.schedule_type === 'value'">&nbsp;{{ getScheduledTaskText(item.payload) }}</span>
    <span v-if="item.payload?.schedule_type === 'variable'"
      >&nbsp;on&nbsp;<span class="font-600" v-if="item.payload?.variable">{{ '{' + item.payload?.variable + '}' }}</span></span
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { WEEKDAYS } from '../../../constants';

export default {
  name: 'ActionScheduleOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    ...mapGetters(['getProjectFlows']),
    payload() {
      return this.item.payload;
    },
    workflow() {
      return this.getProjectFlows()?.[this.payload?.flow_id]?.name || '';
    },
  },
  methods: {
    getScheduledTaskText(item) {
      let timeText;
      if (typeof item.hour === 'number' && item.hour < 10) {
        timeText = `0${item.hour}:`;
      } else if (typeof item.hour === 'string' && item.hour.length === 1) {
        timeText = `0${item.hour}:`;
      } else {
        timeText = `${item.hour}:`;
      }
      if (typeof item.minute === 'number' && item.minute < 10) {
        timeText += `0${item.minute} UTC`;
      } else if (typeof item.minute === 'string' && item.minute.length === 1) {
        timeText += `0${item.minute} UTC`;
      } else {
        timeText += `${item.minute} UTC`;
      }
      if (item.recurring) {
        if (item.frequency === 'minute') {
          if (item.schedule === 1) {
            return `every minute`;
          }
          return `every ${item.schedule} minutes`;
        }
        if (item.frequency === 'hour') {
          if (item.schedule === 1) {
            return `every hour`;
          }
          return `every ${item.schedule} hours`;
        }
        if (item.frequency === 'day') {
          if (item.schedule === 1) {
            return `everyday at ${timeText}`;
          }
          return `every ${item.schedule} days at ${timeText}`;
        }
        if (item.frequency === 'month') {
          // Convert all numbers to their ordinal form
          let ordinalDay;
          const lastDigit = item.schedule % 10;
          switch (lastDigit) {
            case 1:
              ordinalDay = `${item.schedule}st`;
              break;
            case 2:
              ordinalDay = `${item.schedule}nd`;
              break;
            case 3:
              ordinalDay = `${item.schedule}rd`;
              break;
            default:
              ordinalDay = `${item.schedule}th`;
              break;
          }
          return `${ordinalDay} day of every month at ${timeText}`;
        }
        if (item.frequency === 'bi-month') {
          // Convert all numbers to their ordinal form
          let ordinalDay;
          const lastDigit = item.schedule % 10;
          switch (lastDigit) {
            case 1:
              ordinalDay = `${item.schedule}st`;
              break;
            case 2:
              ordinalDay = `${item.schedule}nd`;
              break;
            case 3:
              ordinalDay = `${item.schedule}rd`;
              break;
            default:
              ordinalDay = `${item.schedule}th`;
              break;
          }
          return `${ordinalDay} day of every other month at ${timeText}`;
        }
        if (item.frequency === 'quarter') {
          // Convert all numbers to their ordinal form
          let ordinalDay;
          const lastDigit = item.schedule % 10;
          switch (lastDigit) {
            case 1:
              ordinalDay = `${item.schedule}st`;
              break;
            case 2:
              ordinalDay = `${item.schedule}nd`;
              break;
            case 3:
              ordinalDay = `${item.schedule}rd`;
              break;
            default:
              ordinalDay = `${item.schedule}th`;
              break;
          }
          return `${ordinalDay} day of every quarter at ${timeText}`;
        }
        if (item.frequency === 'weekday') {
          const weekday = WEEKDAYS.find((w) => w.value === item.schedule);
          if (weekday) {
            const dayText = WEEKDAYS.find((w) => w.value === item.schedule).label;
            return `every ${dayText} at ${timeText}`;
          }
        }
      } else {
        if (item.frequency === 'minute') {
          if (item.schedule === 1) {
            return `in ${item.schedule} minute`;
          }
          return `in ${item.schedule} minutes`;
        }
        if (item.frequency === 'hour') {
          if (item.schedule === 1) {
            return `in ${item.schedule} hour`;
          }
          return `in ${item.schedule} hours`;
        }
        if (item.frequency === 'day') {
          if (item.schedule === 1) {
            return `in ${item.schedule} day at ${timeText}`;
          }
          return `in ${item.schedule} days at ${timeText}`;
        }
        if (item.frequency === 'weekday') {
          const weekday = WEEKDAYS.find((w) => w.value === item.schedule);
          if (weekday) {
            const dayText = WEEKDAYS.find((w) => w.value === item.schedule).label;
            return `on ${dayText} at ${timeText}`;
          }
        }
      }
      return '';
    },
  },
};
</script>
